/* DSL Recently-viewed — laatste 12 producten in localStorage */
(function(){
  var KEY = "dsl_recent", MAX = 12;
  function get(){ try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch(e){ return []; } }
  function add(handle){
    if (!handle) return;
    var arr = get().filter(function(h){ return h !== handle; });
    arr.unshift(handle);
    arr = arr.slice(0, MAX);
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch(e){}
  }
  // Detect product page handle from path
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (m) add(m[1]);
  window.DSL_RECENT = {get: get, add: add};
})();